import type { Dispatch, SetStateAction } from 'react';
import { Link } from 'react-router-dom';
import SortableTable from '../../components/SortableTable';
import { usePagePreviewHover } from '../../components/pagePreview/usePagePreviewHover';
import { decisionMargin, type ClusterResponse } from './insights';

export function MembersTable({
  pages,
  selectedRows,
  setSelectedRows,
}: {
  pages: ClusterResponse['pages'];
  selectedRows: Set<string>;
  setSelectedRows: Dispatch<SetStateAction<Set<string>>>;
}) {
  const { show, hide } = usePagePreviewHover();

  return (
    <SortableTable
      storageId="category-cluster-members"
      data={pages}
      rowKey={(row) => row.id}
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      onRowMouseEnter={(row, e) => show(row, e.currentTarget.getBoundingClientRect())}
      onRowMouseLeave={hide}
      columns={[
        {
          label: 'Page',
          accessor: 'id',
          sortable: true,
          render: (page) => (
            <Link
              to={`/document-pages/${page.id}`}
              className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400"
              onClick={(e) => e.stopPropagation()}
            >
              {page.id.slice(0, 8)}…{page.id.slice(-6)}
            </Link>
          ),
        },
        {
          label: 'Top classification',
          accessor: 'classificationCategory',
          sortable: true,
          render: (page) => page.classificationCategory,
        },
        {
          label: 'Score',
          accessor: 'classificationScore',
          sortable: true,
          render: (page) => `${(page.classificationScore * 100).toFixed(0)}%`,
        },
        {
          label: 'Margin',
          accessor: 'margin',
          render: (page) => `${(decisionMargin(page) * 100).toFixed(0)}pp`,
        },
        {
          label: 'Similarity',
          accessor: 'similarityToCentroid',
          sortable: true,
          render: (page) => (
            <span className={page.isOutlier ? 'text-red-600 dark:text-red-400' : undefined}>
              {(page.similarityToCentroid * 100).toFixed(0)}%
            </span>
          ),
        },
      ]}
    />
  );
}
